module.exports = __webpack_public_path__ + "static/img/weather49.83fa1522.png";